import { GetStaticProps } from 'next'

import query from './queries'

import initApollo, { API } from 'src/api'

export type Props = API.Jobs

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.Jobs>({
    query,
  })

  return {
    props: data,
  }
}
